import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateCampaignGeneralDetailsRequest extends BaseUpdateRequest {
    ownerId: string;
    branchId: string;
    deskId: string;
    name: string;
    categoryId: string;
}